<template>
  <modal
    name="main-curtain"
    :shiftX="0"
    class="main-curtain"
    classes="main-curtain-wrapper"
    :adaptive="true"
    :scrollable="true"
    :reset="false"
    @before-open="beforeOpen"
    @closed="closed"
  >
    <div class="main-curtain-wrapper__container" :class="{ 'app-ios': isIOS }">
      <app-circle-btn
        :size="responsive.isMobile ? 'large' : 'largest'"
        @click="$modal.hide('main-curtain')"
        class="main-curtain-wrapper__close"
      ></app-circle-btn>
      <simplebar class="main-curtain-wrapper__scroll">
        <portal-target name="portal-curtain"></portal-target>
      </simplebar>
      <div
        v-touch:swipe.right="handlerSwipe"
        class="main-curtain-wrapper__decor"
      >
        <div class="main-curtain-wrapper__decor-line"></div>
      </div>
    </div>
  </modal>
</template>

<script>
import simplebar from 'simplebar-vue';
import { rootMapper } from '@/store/root';
import browser from '@/helpers/browser';

export default {
  inject: ['responsive'],
  name: 'AppMainCurtain',
  components: {
    simplebar,
    AppCircleBtn: () => import('@/components/ui/AppCircleBtn'),
  },
  computed: {
    isIOS() {
      return browser.isIos;
    },
  },
  methods: {
    ...rootMapper.mapMutations(['IS_CLOSE_CURTAIN', 'IS_OPEN_CURTAIN']),
    /**
     * Открытие шторки
     */
    beforeOpen() {
      this.IS_OPEN_CURTAIN();
    },
    /**
     * Закрытие шторки
     */
    closed() {
      this.IS_CLOSE_CURTAIN();
    },
    /**
     * Событие свайпа
     */
    handlerSwipe() {
      this.$emit('swipe');
    },
  },
};
</script>

<style lang="scss">
// использовать внутри порталов
.main-curtain-header {
  flex-shrink: 0;
}
// использовать внутри порталов
.main-curtain-body {
  flex-grow: 1;
}

.main-curtain-wrapper {
  top: 52px !important;
  left: 320px !important;
  z-index: 2;
  width: calc(100vw - 320px) !important;
  height: calc(100vh - #{$header-height}) !important;
  height: calc(var(--vh, 1vh) * 100 - #{$header-height} + 11px) !important;

  @include media-md() {
    left: 254px !important;
    width: calc(100vw - 254px) !important;
  }

  @include media-sm() {
    left: 120px !important;
    width: calc(100vw - 120px) !important;
  }

  @include media-xs() {
    top: 14px !important;
    left: 14px !important;
    width: calc(100vw - 14px) !important;
    height: calc(100vh - 14px) !important;
    height: calc(var(--vh, 1vh) * 100 - 14px) !important;
  }

  &__container {
    position: relative;
    width: 100%;
    height: 100%;
  }

  &__decor {
    position: absolute;
    top: 0;
    bottom: 0;
    left: -20px;
    width: 40px;
  }

  &__decor-line {
    position: absolute;
    top: calc(50% - 26.5px);
    left: 31px;
    width: 5px;
    height: 53px;
    background-color: $gray-light;
    border-radius: 10px;

    @include media-xs() {
      top: calc(50% - 20px);
      left: 29px;
      width: 4px;
      height: 40px;
    }
  }

  &__scroll {
    height: 100%;
    padding: 25px 54px 0 36px;

    @include media-xs() {
      padding-top: 20px;
      padding-right: 20px;
      padding-left: 20px;
    }

    .vue-portal-target {
      display: flex;
      flex-direction: column;
      align-content: flex-start;
      min-height: calc(100vh - 66px);

      @include media-xs() {
        min-height: calc(100vh - 34px);
      }
    }
  }

  &__close {
    position: absolute;
    top: 14px;
    right: 14px;
    z-index: 99;

    @include media-xs() {
      top: 9px;
      right: 10px;
    }
  }
}
</style>
